import React from 'react';




const HelpInfo = () => {
    return (
        <small className="form-text text-muted">Caso tenha alguma dificuldade, <a
            href="https://glpi.ufvjm.edu.br/plugins/formcreator/front/formdisplay.php?id=106"
            target="_blank" rel="noopener noreferrer">clique aqui</a> para abrir um chamado de suporte.
        </small>
    )
}

export {HelpInfo};